// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import core from '@bmp-vue/core'
import errors from './plugins/multiploErrors'
import 'phosphor-icons'

(async () => {
  window.env = process.env
  const env = { VUE_APP_AMBIENTE: localStorage.ambiente }
  if (localStorage.ambiente && localStorage.ambiente !== process.env.VUE_APP_AMBIENTE) {
    const data = await axios.get('/.env/.env.' + localStorage.ambiente)
    data.data.replaceAll('\r', '\n').replaceAll('\n\n', '\n').split('\n').forEach(line => {
      const [key, val] = line.split(/\s*=\s*(.+)/)
      if (key) { env[key] = val }
    })
    window.env = { ...process.env, ...env }
  }

  const controllers = require.context('./controllers', true, /\.js$/)

  const customControllers = [require('@/plugins/controller.js').default]
  const theme = require('@/plugins/theme').default
  const paths = require('@/plugins/paths').default

  const App = () => import('./App')

  Vue.config.productionTip = false;
  Vue.use(errors);
  Vue.use(core, {
    controllers,
    customControllers,
    paths,
    theme,
    extendRouterBeforeEach: function (vm, to, from, next) {
      const permite = vm.$empresa && vm.$empresa.codigo && vm.$empresa.codigo !== vm.global.GuidEmpty
      const isAmbienteOnboarding = vm.$aux.AmbientesOnboardingSubParceiros.includes(localStorage.ambiente) || vm.$aux.AmbientesOnboardingSubParceiros.includes(process.env.VUE_APP_AMBIENTE)
      const isLoginToken = sessionStorage.getItem('isLoginToken')

      if (!isLoginToken && isAmbienteOnboarding) {
        const existeSubparceiro = vm.$store.state.onboarding.listaSubparceiros
        const isSubparceiroSelected = localStorage.getItem('isSubparceiroSelected') === 'true'
        if (existeSubparceiro && !isSubparceiroSelected) {
          localStorage.setItem('isSubparceiroSelected', 'false')
          return false
        }
      }

      if (to.fullPath === '/parceiro' && permite) {
        return false
      }

      if (vm.$store._actions[`${window.env.VUE_APP_CUSTOMIZACAO}/beforeEach`]) { vm.$store.dispatch(`${window.env.VUE_APP_CUSTOMIZACAO}/beforeEach`, { to, from, next }) }

      return permite
    },
    extendRouterUserHasRole: function (vm, acao) {
      return { stop: true, result: vm.$actions.indexOf(acao) >= 0 }
    },
    mount: async (options) => {
      require('@/components')

      const _this = Vue.prototype

      Vue.config.errorHandler = (error) => _this.$api.ErrorService.onError(error);

      const responseEmpresa = await _this.$api.Empresa.GetByAmbiente()
      _this.$bancodofuturo = responseEmpresa.bancoDoFuturo ? 'bancodofuturo' : 'legado'
      window.$bancodofuturo = responseEmpresa.bancoDoFuturo ? 'bancodofuturo' : 'legado'

      if (!_this.$store.getters.empresa || window.env.VUE_APP_AMBIENTE !== _this.$store.getters.empresa.ambiente) {
        if (_this.$api.UI.PostLoadData(responseEmpresa)) {
          _this.$store.commit('empresa', responseEmpresa)
        }
      }
      _this.$empresa = _this.$store.getters.empresa
      const dtoParams = {
        parameters: [
          { name: 'codigoEmpresa', value: _this.$store.getters.empresa.codigo }
        ]
      }

      const responseParam = await _this.$api.Parametro.GetAll(dtoParams)

      const $param = {}

      responseParam.forEach(p => {
        try {
          $param[p.identificador] = JSON.parse(p.valor)
        } catch {
          try {
            // eslint-disable-next-line no-eval
            $param[p.identificador] = eval(p.valor)
          } catch {
            $param[p.identificador] = p.valor
          }
        }
      })

      _this.$param = $param

      const $aux = {}

      const responseAuxiliar = await _this.$api.Auxiliar.GetAll()
      responseAuxiliar.forEach(p => {
        try {
          $aux[p.identificador] = JSON.parse(p.itens)
        } catch {
          try {
            // eslint-disable-next-line no-eval
            $aux[p.identificador] = eval(p.itens)
          } catch {
            $aux[p.identificador] = []
          }
        }
      })

      _this.$aux = $aux

      _this.$actions = await _this.$api.ActionGroupAccess.GetAll()

      const stores = require('@/plugins/store.js').default

      stores.forEach(p => {
        if (p.logoutFunctions) {
          _this.$store.commit('logoutFunctions', p.logoutFunctions)
        }
        _this.$store.registerModule(p.name, p)
      })
      const app = new Vue({
        ...options,
        render: h => h(App)
      }).$mount('#app')
      if (window.Cypress) {
        window.__app__ = app
      }

      const empresa = _this.$store.getters.empresa
      const portalEnabledIdVisual = await _this.$api.Portal.GetIdVisualPortalEnabled(empresa?.codigoPortal)
      if (portalEnabledIdVisual) {
        const customJSONPortal = await _this.$api.Portal.GetIdVisualPortal(empresa?.codigoPortal)

        if (customJSONPortal?.cores?.length) {
          const customTheme = Object.fromEntries(
            customJSONPortal.cores.map(item => [item.variavel, item.cor])
          )

          app.$vuetify.theme.themes.light = {
            ...app.$vuetify.theme.themes.light,
            ...customTheme
          }

          if (app.$vuetify.theme.themes.dark) {
            app.$vuetify.theme.themes.dark = {
              ...app.$vuetify.theme.themes.dark,
              ...customTheme
            }
          }
        }
      }
    }
  })

  Vue.mixin({
    data: function () {
      return {
        allowedFiles: '.pdf, .bmp, .doc, .docx, .txt, .xls, .xlsx, .zip, image/jpg, image/jpeg, image/png, image/gif',
        fileSize: '6MB'
      }
    }
  })
})()
